import { combineReducers } from "redux";
import {
  REQUEST_FAIL,
  REQUEST,
  POST_COMPLETE,
  POST_OK,
  RESET
} from "./constants";
import wrapperReducer from "redux/containers/wrapperReducer";

const initialState = {
  isFetching: false,
  list: [],
  selected: [],
  errors: ""
};

const main = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return {
        ...initialState
      };

    case REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case REQUEST_FAIL:
      return {
        ...state,
        isFetching: false,
        errors: action.errors
      };

    case POST_OK:
      return {
        ...state,
        isFetching: false,
        list: action.payload.list,
        errors: action.errors
      };

    case POST_COMPLETE:
      return {
        ...state,
        isFetching: false,
        errors: action.errors
      };

    default:
      return state;
  }
};

export default combineReducers({
  bannerplaces: wrapperReducer(main, "bannerplaces")
});
